<script setup lang="ts">
import { isPlatformHg } from '@/helpers/Platform/Platform';
import { HgIcon, HgNotificationMessage, HgToast } from '@smg-real-estate/domus';

const isHg = isPlatformHg();

interface Props {
  isShowingNotificationToast: boolean;
  isContactFormSubmitSuccessfully: boolean;
}

defineProps<Props>();
const emit = defineEmits<{
  /**
   * Is emitted when toast times out
   */
  clear: [];
}>();
</script>

<template>
  <HgToast
    :isVisible="isShowingNotificationToast"
    @clear="
      () => {
        emit('clear');
      }
    "
  >
    <HgNotificationMessage
      :title="
        isContactFormSubmitSuccessfully
          ? $t('localLanding.contactForm.submitSuccessTitle')
          : $t('localLanding.contactForm.submitFailedTitle')
      "
      :theme="isContactFormSubmitSuccessfully ? 'success' : 'danger'"
      :showCloseButton="true"
    >
      <template #icon>
        <HgIcon
          :icon="
            isContactFormSubmitSuccessfully ? (isHg ? 'Success' : 'CheckmarkCircleSolid') : 'Error'
          "
          :color="isContactFormSubmitSuccessfully ? 'success' : 'danger'"
          size="large"
        />
      </template>
      <p>
        {{
          isContactFormSubmitSuccessfully
            ? $t('localLanding.contactForm.submitSuccessMessage')
            : $t('localLanding.contactForm.submitFailedMessage')
        }}
      </p>
    </HgNotificationMessage>
  </HgToast>
</template>
